import { axiosV2 } from 'interceptors/axios';
import { Dispatch } from 'redux';

import { ApiQueryParams } from 'types/ApiQueryParams';

import { dispatchError } from 'utils/dispatchError';
import { decryptResponse } from 'utils/token';

type GetSharesByHoldingClassOrPartnerProps = {
  holdingClassId?: string;
  partnerId?: string;
  params: ApiQueryParams;
};

export const getSharesByHoldingClassOrPartner =
  ({
    holdingClassId,
    partnerId,
    params,
  }: GetSharesByHoldingClassOrPartnerProps) =>
  async (dispatch: Dispatch) => {
    const query = { params: { holdingClassId, partnerId, ...params } };

    try {
      const { data } = await axiosV2.get(
        '/shares/by-holding-class-or-partner',
        query
      );

      const decodedData = await decryptResponse(data);

      return decodedData;
    } catch (error) {
      dispatchError(error, dispatch);
      return {
        shares: [],
        total: 0,
      };
    }
  };
